
var sprite = require("/tmp/build_27def88f/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 23 21\" id=\"icon_share_jax_10febc28acbe646984ba0447566c753f\" ><path d=\"M21.687 15.063v1.853c0 1.534-1.22 2.778-2.725 2.778H3.513c-1.506 0-2.726-1.244-2.726-2.778v-1.853m10.45-13.316v12.635m-6.65-5.856l6.65-6.779 6.65 6.78\" stroke-width=\"1.2\" fill=\"none\"/></symbol>";
module.exports = sprite.add(image, "icon_share_jax_10febc28acbe646984ba0447566c753f");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon_share.svg
// module id = 1422
// module chunks = 1